module.exports = __webpack_public_path__ + "static/media/shoe3.8d0d4818.jpeg";